import { useQuery } from '@hooks/reactQuery';

import { getGoldenSettingsDates } from '@api/goldenSettings';

import { extractQueryParams } from '@utils/common';
import { getDateWithoutOffset } from '@utils/kpi-utils/date';

import { TCMDefaultDTO } from '@interfaces/cmModule/dto/cmModuleDTO';

import { refetchOptions } from '@constants/common';
import { GOLDEN_SETTING_DATES } from '@constants/queryKeys';

interface IUseQueryGoldenSettingsDatesReturnType {
	goldenSettingsDates: Date[];
	isLoadingGoldenSettingsDates: boolean;
}

const useQueryGoldenSettingsDates = (
	params: Partial<TCMDefaultDTO>,
): IUseQueryGoldenSettingsDatesReturnType => {
	const {
		vendor,
		technology,
		nodeType,
		siteIds = [],
	} = params;

	const {
		data: goldenSettingsDates,
		isLoading: isLoadingGoldenSettingsDates,
		isFetching: isFetchingGoldenSettingsDates,
	} = useQuery({
		queryKey: [GOLDEN_SETTING_DATES, params],
		queryFn: extractQueryParams(getGoldenSettingsDates),
		select: (data: number[]) => data.map((date) => getDateWithoutOffset(date)),
		enabled: [vendor, technology, nodeType, siteIds.length],
		...refetchOptions,
	});

	return {
		goldenSettingsDates: goldenSettingsDates || [],
		isLoadingGoldenSettingsDates: (isLoadingGoldenSettingsDates && !!goldenSettingsDates)
			|| isFetchingGoldenSettingsDates,
	};
};

export default useQueryGoldenSettingsDates;
